import type { RouteRecordRaw } from 'vue-router';
import { SETUP_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const setupTurnTrackerRoutes: RouteRecordRaw = {
  path: '/setup/turn-tracker',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    { name: SETUP_ROUTE_NAME.TURN_TRACKER_SETUP, path: '', component: () => import('./SetupTurnTracker.vue') },
  ],
};
